import { useSetAtom } from 'jotai';

import type { ImageAnalyses } from '../../../../@types/latestImagesV2';
import type { TClaimNote, TFlattenedTreatment } from '../../../../@types/rcm';
import { usePreferences } from '../../../../react-query/usePreferences';
import { insPagesAtom } from '../state';

import { ImageInfo } from './ImageInfo';
import { PatientInfo } from './PatientInfo';

export type SummaryConfigProps = {
  images: ImageAnalyses[];
  filteredTeethList: string[];
  defaultTeethList: string[];
  estimatedVisitId: number;
  unifiedAppointmentId?: number;
  isSrp: boolean;
  defaultTreatments: TFlattenedTreatment[];
  treatmentsToUse: TFlattenedTreatment[];
  radiographsTakenDate: string;
  claimNotes: TClaimNote[];
  onSelectTreatments: (txIds: string[]) => void;
  onSelectBitewingOnly: (isBitewingOnly: boolean) => void;
};

export function SummaryConfig({
  estimatedVisitId,
  unifiedAppointmentId,
  isSrp,
  defaultTreatments,
  treatmentsToUse,
  radiographsTakenDate,
  claimNotes,
  onSelectTreatments,
  onSelectBitewingOnly,
}: SummaryConfigProps) {
  const { data: preferences } = usePreferences();

  const setInsPage = useSetAtom(insPagesAtom);

  return (
    <div className="vai-grid vai-grid-cols-[1fr_1fr] vai-gap-4 vai-h-full">
      <div className="vai-p-4 vai-rounded-lg">
        <PatientInfo
          preferences={preferences}
          estimatedVisitId={estimatedVisitId}
          unifiedAppointmentId={unifiedAppointmentId}
          defaultTreatments={defaultTreatments}
          treatmentsToUse={treatmentsToUse}
          isSrp={isSrp}
          onSelectTreatments={onSelectTreatments}
          onSetInsPage={(page) => setInsPage(page)}
        />
      </div>
      <div className="vai-p-4 vai-rounded-lg">
        <ImageInfo
          onSelectBitewingOnly={onSelectBitewingOnly}
          radiographsTakenDate={radiographsTakenDate}
          claimNotes={claimNotes}
        />
      </div>
    </div>
  );
}
